import {
  PersonIdentity,
  personFullName,
  type PersonIdentityData,
} from '@/components/person-identity'
import type { ReactNode } from 'react'

export const contactDisplayName = personFullName

export function ContactIdentity({
  contact,
  className,
  detail,
}: {
  contact: PersonIdentityData
  className?: string
  detail?: ReactNode
}) {
  return (
    <PersonIdentity person={contact} className={className} detail={detail} />
  )
}
